import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/icon_default_message.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-fill" }, null, -1)
const _hoisted_2 = { class: "text-center sticky-top mb-3" }
const _hoisted_3 = {
  class: "badge bg-white text-primary text-label",
  style: {"width":"76px"}
}
const _hoisted_4 = {
  key: 0,
  class: "bg-light py-3 px-3 rounded-5 d-flex mb-3 justify-content-center align-items-center position-relative"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "30",
  class: "position-absolute start-0 ms-4"
}, null, -1)
const _hoisted_6 = {
  class: "mb-0 text-center text-label",
  style: {"width":"400px"}
}
const _hoisted_7 = {
  key: 1,
  class: "text-center sticky-top"
}
const _hoisted_8 = {
  class: "badge bg-white border-light text-primary text-label",
  style: {"width":"76px"}
}
const _hoisted_9 = {
  key: 2,
  class: "d-flex mb-3"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "mb-0 text-subtitle me-3" }
const _hoisted_13 = { class: "mb-0 text-label text-muted" }
const _hoisted_14 = { class: "text-paragraph" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.formattedDate), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectionItems, (item, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        (item.isDefault)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.defaultMessage), 1)
            ]))
          : _createCommentVNode("", true),
        (item.isHeader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(item.title), 1)
            ]))
          : _createCommentVNode("", true),
        (!item.isHeader && !item.isDefault)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("img", {
                src: item.image,
                alt: "",
                height: "38",
                width: "38",
                class: "rounded-circle me-3 mt-1"
              }, null, 8, _hoisted_10),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", _hoisted_12, _toDisplayString(item.name), 1),
                  _createElementVNode("p", _hoisted_13, _toDisplayString(item.time), 1)
                ]),
                _createElementVNode("p", _hoisted_14, _toDisplayString(item.message), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}